import React from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';

const LoaderAllScreen = ({active}) => {
  return (
    <>
      <Dimmer inverted active={active}>
        <Loader size='large'/>
      </Dimmer>
    </>
  );
};

export default LoaderAllScreen;
